import Box from '@mui/material/Box';
import { FormCheckBox, useTrackedFormik } from '@omnigenbiodata/ui';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { StepProps } from '../../../../core/types/common.types';
import EnrolmentStepContainer from '../EnrolmentStepContainer';

function Consent7Step({ currentStep, onStepForward, onStepBack, values }: StepProps) {
  const { t } = useTranslation('portal');

  const validationSchema = yup.object().shape({
    consent7: yup
      .boolean()
      .required(t('forms.consent7.msg.required') as string)
      .oneOf([true], t('forms.consent7.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { consent7: false, ...values },
      validationSchema,
      onSubmit: (values: any) => {
        onStepForward(values);
      },
    },
    'consent7',
  );

  return (
    <EnrolmentStepContainer
      onSubmit={formik.handleSubmit}
      title={t('enrol.consent7.title')}
      text={t('enrol.consent7.text') as string}
      onBack={onStepBack}
      showBack={currentStep > 0}
    >
      <Box mb={4} px={{ xs: 3, sm: 0 }}>
        <FormCheckBox
          error={formik.errors.consent7}
          name="consent7"
          label={t('forms.consent7.label')}
          onChange={formik.handleChange}
          touched={formik.touched.consent7}
          value={formik.values.consent7}
        />
      </Box>
    </EnrolmentStepContainer>
  );
}

export default Consent7Step;
